import React, { useState, useRef } from 'react';
import { Upload, Link, X, Image } from 'lucide-react';
import adminApi from '../api/adminApi';

const ImagePicker = ({ label, value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadError(null);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await adminApi.post('/admin/media/upload', formData);
      onChange(data.url);
    } catch (err) {
      setUploadError(err.response?.data?.detail || 'Upload failed');
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div className="space-y-2">
      {label && <label className="block text-xs uppercase tracking-wider text-[#D4AF37] font-semibold">{label}</label>}
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Link className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
          <input
            type="text"
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            placeholder="/uploads/example.png or upload below"
            className="w-full bg-[#1A1A1A] border border-[rgba(212,175,55,0.2)] rounded-sm pl-9 pr-3 py-2 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition-colors"
          />
        </div>
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 px-3 py-2 bg-[rgba(212,175,55,0.1)] border border-[rgba(212,175,55,0.3)] text-[#D4AF37] text-sm rounded-sm hover:bg-[rgba(212,175,55,0.2)] transition-colors disabled:opacity-50"
        >
          <Upload className="w-4 h-4" />
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
        <input ref={fileRef} type="file" accept="image/*" onChange={handleUpload} className="hidden" />
      </div>
      {uploadError && <p className="text-red-400 text-xs">{uploadError}</p>}
      {value && (
        <div className="relative w-full h-32 rounded-sm overflow-hidden border border-[rgba(212,175,55,0.2)] bg-[#0A0A0A] group">
          <img src={value} alt="Preview" className="w-full h-full object-cover" onError={e => { e.target.style.display = 'none'; }} />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute top-2 right-2 w-6 h-6 bg-black/70 rounded-full flex items-center justify-center text-white/70 hover:text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X className="w-3 h-3" />
          </button>
          {!value && <div className="absolute inset-0 flex items-center justify-center"><Image className="w-8 h-8 text-white/20" /></div>}
        </div>
      )}
    </div>
  );
};

export default ImagePicker;
